import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from "@apollo/client";

const useImperativeQuery = <TData = any, TVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  option?: QueryHookOptions<TData, TVariables>
) => {
  const { refetch } = useQuery(query, { skip: true, ...option });

  const imperativelyCallQuery = (variables?: Partial<TVariables>) => {
    return refetch(variables);
  };

  return imperativelyCallQuery;
};

export default useImperativeQuery;
